// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2Cx7L","label":"Labeled_label__3_LVe","divider":"Labeled_divider__t4rxg"};